import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ModalProvider } from "./modal/context";
import { getAuthHost } from "./utils";
import WithAuthentication from "./auth";

// bootstrap
// import "bootstrap/dist/css/bootstrap.css";
import "jquery/dist/jquery"
import "bootstrap/dist/js/bootstrap"
import "popper.js/dist/popper"


ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <WithAuthentication
        host={getAuthHost()}
        hideMicrosoftSSO={false}
        postLoginPage="/catalog"
      >
        <ModalProvider>
          <App />
        </ModalProvider>
      </WithAuthentication>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
